export default __webpack_public_path__ + "static/media/d_wdt_c_2.1558555a.mp3";